/**
 * Progress board design tokens (29.38).
 * One radius, one border, one padding scale, one type ladder —
 * so receipt cards, collection rows, and tiles share the same rhythm.
 */

export const SUCCESS_HUB_PROGRESS_TOKENS = Object.freeze({
  radius: Object.freeze({
    /** Outer mayo surfaces (header, momentum, Locked in, missions). Fold cue is rule+line, not a surface. */
    surface: '14px',
    /** Nested rows inside a surface (receipts, collections, tiles). */
    row: '12px',
    /** Coded marks / stage chips. */
    mark: '10px',
  }),
  borderWidth: '1px',
  borderColourFallback: 'rgba(0, 0, 0, 0.06)',
  space: Object.freeze({
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '20px',
  }),
  pad: Object.freeze({
    /** Outer surface inset. */
    surface: '16px 18px',
    /** Nested row inset — receipts, collections, tiles share this. */
    row: '14px 16px',
    /** Today’s job card (loudest surface; still on the same scale). */
    job: '24px 28px 20px',
  }),
  type: Object.freeze({
    display: 'clamp(2.25rem, 4.5vw, 2.75rem)',
    jobTitle: 'clamp(1.75rem, 2.6vw, 2rem)',
    heading: '1.0625rem',
    body: '0.875rem',
    lead: '0.8125rem',
    rowTitle: '0.875rem',
    rowMeta: '0.8125rem',
    meta: '0.75rem',
    micro: '0.6875rem',
  }),
  /**
   * Soft progress meters (29.42) — Locked-in set + collection rows only.
   * Thin hairlines; complete fills stay olive-quiet (no seaweed yell).
   * Momentum % bar is intentionally separate and unchanged.
   */
  meter: Object.freeze({
    set: '3px',
    collection: '2px',
  }),
})

const T = SUCCESS_HUB_PROGRESS_TOKENS

/** Outer card / panel border. */
export function successHubProgressSurfaceBorder(theme) {
  return `${T.borderWidth} solid ${
    theme?.colours?.chipGrey || T.borderColourFallback
  }`
}

/** Nested pale row — same width as surface border, transparent fill edge. */
export function successHubProgressRowBorder() {
  return `${T.borderWidth} solid transparent`
}
